export default "/images/logo-123-horizontal.png?7586bbb091b28060f1c34cf3df86fc6d";